const SHIPPING_MODEL_CLASS_NAME = 'Shipping'

const SHIPPING_MODEL_KEY = {
  NAME: 'name',
  CODE: 'code',
  PRICE: 'price',
  DELIVERY_TIME: 'deliveryTime',
  HAS_TRACKING: 'hasTracking',
  LOCAL_IS_FREE: 'localIsFree'
}

const SHIPPING_MODEL_KEY_POINTER = SHIPPING_MODEL_KEY.CODE

export {
  SHIPPING_MODEL_KEY,
  SHIPPING_MODEL_KEY_POINTER,
  SHIPPING_MODEL_CLASS_NAME
}
